import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Trainingsplan from "../views/Trainingsplan";
import Vorstand from "../views/Vorstand";
import BeitrageUGebuhren from "../views/BeitrageUGebuhren";
import FormulareUDownloads from "../views/FormulareUDownloads";
import Impressum from "../views/Impressum";

Vue.use(VueRouter);

const SITE_URL = "https://sc-budokwai.de";
const DEFAULT_TITLE = "Judo in Garbsen - SC Budokwai Garbsen e.V.";
const DEFAULT_DESCRIPTION =
  "Judo in Garbsen: Der SC Budokwai Garbsen e.V. bietet Judotraining für Kinder, Jugendliche und Erwachsene. Kostenloses Probetraining – komm einfach vorbei!";

// Alte Hash-URLs (z.B. /#/trainingsplan) auf die neuen Pfade umleiten
if (window.location.hash.startsWith("#/")) {
  window.history.replaceState(null, "", window.location.hash.slice(1));
}

const routes = [
  {
    path: "/",
    name: "",
    component: Home,
    meta: {
      title: DEFAULT_TITLE,
      description: DEFAULT_DESCRIPTION,
    },
  },
  {
    path: "/trainingsplan",
    name: "Trainingsplan",
    component: Trainingsplan,
    meta: {
      title: "Trainingsplan - SC Budokwai Garbsen e.V.",
      description:
        "Alle Judo-Trainingszeiten des SC Budokwai Garbsen e.V. für Kinder, Jugendliche und Erwachsene in der IGS Garbsen und der Turnhalle Stelingen. Probetraining kostenlos!",
    },
  },
  {
    path: "/vorstand",
    name: "Vorstand",
    component: Vorstand,
    meta: {
      title: "Unser Vorstand - SC Budokwai Garbsen e.V.",
      description:
        "Der Vorstand des SC Budokwai Garbsen e.V. – eure Ansprechpartner für Mitgliedschaft, Training und alle Fragen rund um den Judoverein in Garbsen.",
    },
  },
  {
    path: "/gebuhren",
    name: "Beiträge & Gebühren",
    component: BeitrageUGebuhren,
    meta: {
      title: "Beiträge & Gebühren - SC Budokwai Garbsen e.V.",
      description:
        "Mitgliedsbeiträge und Gebühren des SC Budokwai Garbsen e.V.: Monatsbeiträge, Aufnahmegebühr, Judopass und Jahressichtmarke im Überblick.",
    },
  },
  {
    path: "/downloads",
    name: "Formulare",
    component: FormulareUDownloads,
    meta: {
      title: "Formulare - SC Budokwai Garbsen e.V.",
      description:
        "Formulare und Downloads des SC Budokwai Garbsen e.V.: Eintrittsformular, Vereinssatzung und Prüfungsordnung für Kyu-Grade als PDF.",
    },
  },
  {
    path: "/impressum",
    name: "Impressum",
    component: Impressum,
    meta: {
      title: "Impressum - SC Budokwai Garbsen e.V.",
      description:
        "Impressum und Datenschutzerklärung des SC Budokwai Garbsen e.V., Judoverein in Garbsen.",
    },
  },
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// Titel, Description und Canonical-URL pro Seite setzen
// (wird beim Prerendering in das statische HTML der jeweiligen Route gebacken)
router.beforeEach((to, from, next) => {
  const title = to.meta.title || DEFAULT_TITLE;
  const description = to.meta.description || DEFAULT_DESCRIPTION;
  const url = SITE_URL + (to.path === "/" ? "/" : to.path);

  document.title = title;

  const setMeta = (selector, content) => {
    const el = document.querySelector(selector);
    if (el) el.setAttribute("content", content);
  };
  setMeta('meta[name="description"]', description);
  setMeta('meta[property="og:title"]', title);
  setMeta('meta[property="og:description"]', description);
  setMeta('meta[property="og:url"]', url);

  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) canonical.setAttribute("href", url);

  next();
});

// Alte Hash-Links abfangen, wenn sich nur der Hash ändert (z.B. Bookmark-Klick
// im selben Tab) — dabei lädt der Browser die Seite nicht neu, sodass der
// replaceState-Redirect oben nicht greift.
window.addEventListener("hashchange", () => {
  if (window.location.hash.startsWith("#/")) {
    router.replace(window.location.hash.slice(1)).catch(() => {});
  }
});

export default router;
